import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrivaLoaderComponent } from '@priva/components/loader';
import { PrivaSpinnerComponent } from '@priva/components/spinner';

import { resetMasterDataState } from 'app/state/master-data/master-data.actions';

@Component({
    selector: 'app-update-pwa',
    templateUrl: './update-pwa.component.html',
    imports: [PrivaLoaderComponent, PrivaSpinnerComponent],
})
export class UpdatePwaComponent {
    constructor(store: Store) {
        store.dispatch(resetMasterDataState());
        setTimeout(() => window.location.replace('/'), 1500);
    }
}
